import { inject, Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { createLogger } from '@hunting-nature/shared-core/logging';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  private readonly platform = inject(Platform);
  private readonly log = createLogger('BrowserService');

  /**
   * Opens an external URL in the system browser
   * @param url - The URL to open
   */
  async openExternalUrl(url: string): Promise<void> {
    try {
      if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
        window.open(url, '_blank');
      } else {
        await Browser.open({ url });
      }
    } catch (error) {
      this.log.error('Failed to open browser', { error });
      throw error;
    }
  }

  async close(): Promise<void> {
    await Browser.close();
  }
}
